import styled from "styled-components";
import {CssRule} from "../../../../../themes/architecture/css-helpers/css-rule";
import {USER_MENU_OPEN} from "../../../../../themes/css-global-classes";

export interface UserMenuRootDefaultBoxProps {
        zIndex: number;
}

export const UserMenuRootDefaultBox = styled.div<UserMenuRootDefaultBoxProps>`
  position: fixed;
  top: 0;
  display: flex;
  flex-direction: column;
  width: 37.5rem;
  height: 100vh;
  background: ${props => props.theme.colors.backgroundMiddleDark};
  transform: translateX(-100%);
  transition: transform 0.5s ease-in-out;
  overflow: hidden;
  z-index: ${props => props.zIndex};
  
  
  @media ${({theme}) => theme.mediaQuery.lAndBelow } {
    flex: 1;
    width: 50vw;
    height: 100%;
    right: 0;
    transform: translateX(100%);
    
    @media ${({theme}) => theme.mediaQuery.sAndBelow } {
      width: 100vw;
    }
    
    @media ${({theme}) => theme.mediaQuery.landscape } {
      width: 50vw;
     
    }
  }
  
  //The reason we use a dedicated class and not an isOpen property for the component 
  //is because this class will give us more CSS specificity otherwise the transform: translateX will not work corectly
  &.${USER_MENU_OPEN} {
    transform: translateX(0);

    @media ${({theme}) => theme.mediaQuery.lAndBelow } {
      @media ${({theme}) => theme.mediaQuery.landscape } {
        padding-right: env(safe-area-inset-right);
        ${CssRule.For.RTL.build()} & {
          padding-left: env(safe-area-inset-left);
        }
      }
    }
  }
`